module.exports = __webpack_public_path__ + "static/media/tmc-supporters.8726c14a.png";